// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"4037a2eb","453":"3e034b6c","796":"7da9665b"}[chunkId] + ".chunk.js";
};